import baseApi from './baseApi';

const apiUrl = process.env.API_URL;

export const requests = {
  sendAmoTcRequest: (data, lang = 'ru') => baseApi.post(`${apiUrl}/amo/tcrequest`, data, { headers: { 'X-Language': lang } }),
  sendContactsFrom: (data, lang = 'ru') => baseApi.post(`${apiUrl}/landing/contact`, data, { headers: { 'X-Language': lang } }),
  setTimeslot: (data, lang = 'ru') => baseApi.post(`${apiUrl}/timeslots`, data, { headers: { 'X-Language': lang } }),
  sendResume: (data, lang = 'ru') => baseApi.post(`${apiUrl}/landing/resume`, data, { headers: { 'X-Language': lang } }),
  sendSettingRequest: (data, lang = 'ru') => baseApi.post(`${apiUrl}/tcrequestspublic/batch`, data, { headers: { 'X-Language': lang } }),

  sendExternalFill: (key, data, lang = 'ru') => baseApi.put(`${apiUrl}/externalinfillspublic/${key}`, data, { headers: { 'X-Language': lang } }),
  sendDataToRenderTemplatesBySeo: (key, data, lang = 'ru') => baseApi
    .post(`${apiUrl}/externalinfillspublic/${key}/render`, data, { headers: { 'X-Language': lang }, responseType: 'blob' }),
  sendExternalAttachments: (key, data, lang = 'ru') => baseApi
    .post(`${apiUrl}/externalinfillspublic/${key}/attachments`, data, { headers: { 'X-Language': lang } }),
  renderTemplateFromSeo: (id, data, lang = 'ru') => baseApi
    .post(`${apiUrl}/sharedtemplatespublic/${id}/createrender`, data, { headers: { 'X-Language': lang } }),
  sendDataToEmail: (id, mail, lang = 'ru') => baseApi
    .post(`${apiUrl}/sharedrenderspublic/${id}/send`, mail, { headers: { 'X-Language': lang } }),
  sendSignCode: (key, data, lang = 'ru') => baseApi
    .put(`${apiUrl}/externalinfillspublic/${key}/signrequest`, data, { headers: { 'X-Language': lang } }),
  signDocumentSubmit: (key, data, lang = 'ru') => baseApi
    .put(`${apiUrl}/externalinfillspublic/${key}/signaccept`, data, { headers: { 'X-Language': lang } }),
  signDocumentDecline: (key, data, lang = 'ru') => baseApi
    .put(`${apiUrl}/externalinfillspublic/${key}/signreject`, data, { headers: { 'X-Language': lang } }),
  signDocumentComment: (key, data, lang = 'ru') => baseApi
    .put(`${apiUrl}/externalinfillspublic/${key}/signcomment`, data, { headers: { 'X-Language': lang } }),
  signDocumentPreview: (key, data, lang = 'ru') => baseApi
    .put(`${apiUrl}/externalinfillspublic/${key}/preview`, data, { headers: { 'X-Language': lang }, responseType: 'blob' }),

  authApiKey: (data, lang = 'ru') => baseApi.post(`${apiUrl}/auth/apikey`, data, { headers: { 'X-Language': lang } }),
  checkApiKey: (data, lang = 'ru') => baseApi.post(`${apiUrl}/apikey/check`, data, { headers: { 'X-Language': lang } }),
  yclientsRegister: (data, lang = 'ru') => baseApi.post(`${apiUrl}/yclientspublic/activate`, data, { headers: { 'X-Language': lang } }),
  yclientsAuth: (data, lang = 'ru') => baseApi.post(`${apiUrl}/auth/yclients`, data, { headers: { 'X-Language': lang } }),

  createUrlToken: (lang = 'ru') => baseApi.post(`${apiUrl}/urltokens`, {}),
  sendTcRequest: (data) => baseApi.post(`${apiUrl}/tcrequests`, data),

  updateWorkspace: (data) => baseApi.put(`${apiUrl}/workspace`, data),

  moveFolder: ({ id, ...data }) => baseApi.put(`${apiUrl}/folders/${id}`, data),
  copyFolder: ({ id, ...data }) => baseApi.post(`${apiUrl}/folders/${id}/copy`, data),
  removeFolder: ({ id, ...data }) => baseApi.delete(`${apiUrl}/folders/${id}`, data),
  changeFolder: ({ id, ...data }) => baseApi.put(`${apiUrl}/folders/${id}`, data),
  createFolder: (data) => baseApi.post(`${apiUrl}/folders`, data),
  favouritesAddFolder: (id) => baseApi.put(`${apiUrl}/folders/favorites/${id}`),
  favouritesRemoveFolder: (id) => baseApi.delete(`${apiUrl}/folders/favorites/${id}`),

  importTemplate: (data) => baseApi.post(`${apiUrl}/templates/doc`, data),
  createTemplate: (data) => baseApi.post(`${apiUrl}/templates`, data),
  setTemplateCrmSides: ({ id, ...data }) => baseApi.put(`${apiUrl}/templates/${id}/crm`, data),
  renderTemplate: ({ id, ...data }) => baseApi.post(`${apiUrl}/templates/${id}/render`, data, { responseType: 'blob' }),
  createCounteragent: (data) => baseApi.post(`${apiUrl}/counteragents`, data),
  addProduct: (data) => baseApi.post(`${apiUrl}/products`, data),

  moveTemplate: ({ id, ...data }) => baseApi.put(`${apiUrl}/templates/${id}`, data),
  copyTemplate: ({ id, ...data }) => baseApi.post(`${apiUrl}/templates/${id}/copy`, data),
  removeTemplate: ({ id, ...data }) => baseApi.delete(`${apiUrl}/templates/${id}`, data),
  changeTemplate: ({ id, ...data }) => baseApi.put(`${apiUrl}/templates/${id}`, data),
  createTemplate: (data) => baseApi.post(`${apiUrl}/templates/`, data),
  restoreTemplate: (id) => baseApi.put(`${apiUrl}/templates/${id}/restore`),
  favouritesAddTemplate: (id) => baseApi.put(`${apiUrl}/templates/favorites/${id}`),
  favouritesRemoveTemplate: (id) => baseApi.delete(`${apiUrl}/templates/favorites/${id}`),

  copySharedTemplate: ({ id, ...data }) => baseApi.post(`${apiUrl}/sharedtemplates/${id}/copy`, data),
};

export const queries = {
  getMainData: (lang) => baseApi.get(`/${lang}/main.json`),
  getPageData: (lang, slug) => baseApi.get(`/${lang}/${slug}.json`),
  getPromoData: (lang, slug) => baseApi.get(`/${lang}/promo/${slug}.json`),
  getHTMLPageData: (lang, slug) => baseApi.get(`/${lang}/pages/${slug}.html`, { responseType: 'text' }),
  getTimezones: (lang) => baseApi.get(`/${lang}/timezones.json`),
  getSeoData: (lang, slug) => baseApi.get(`/${lang}/seo/${slug}.json`),
  getPagesList: (lang, slug) => baseApi.get(`/${lang}/pages/${slug}/index.json`),

  getTariffsData: () => baseApi.get(`${apiUrl}/tariffspublic/`),
  getSignatureTariffs: () => baseApi.get(`${apiUrl}/workspace/signaturetariffs/`),
  getTimeslots: () => baseApi.get(`${apiUrl}/timeslots`),

  getExternalFillItem: (key) => baseApi.get(`${apiUrl}/externalinfillspublic/${key}`),
  getExternalFillAttachment: (key, id) => baseApi.get(`${apiUrl}/externalinfillspublic/${key}/attachments/${id}`, { responseType: 'blob' }),
  getExternalFillOwner: (wid, id) => baseApi.get(`${apiUrl}/externalinfillentities/${wid}/${id}`),
  getSignDocumentStatus: (key, lang = 'ru') => baseApi.get(`${apiUrl}/externalinfillspublic/${key}/sign`),
  getSeoTemplateByID: (id) => baseApi.get(`${apiUrl}/sharedtemplatespublic/${id}`),
  getSeoTemplateContent: (id) => baseApi.get(`${apiUrl}/sharedtemplatespublic/${id}/content`),
  getSeoTemplateSides: (id) => baseApi.get(`${apiUrl}/sharedtemplatespublic/${id}/sides`),
  getSeoTemplatePreviews: (id) => baseApi.get(`${apiUrl}/sharedtemplatespublic/${id}/previews`),
  getSharedFolders: () => baseApi.get(`${apiUrl}/sharedfolderspublic`),
  getSharedTemplates: () => baseApi.get(`${apiUrl}/sharedtemplatespublic`),
  getMailDomain: (mail) => baseApi.get(`${apiUrl}/maildomain?email=${mail}`),
  getAreasOfActivity: () => baseApi.get(`${apiUrl}/areasOfActivityPublic/all`),
  sendToRenderDocument: (idTemplate, idDocument, type) => baseApi
    .get(
      `${apiUrl}/sharedtemplatespublic/${idTemplate}/render/${idDocument}?format=${type}`,
      { responseType: 'blob' }
    ),

  getFavouritesFolders: () => baseApi.get(`${apiUrl}/folders/favorites`),
  getRootFolderContent: () => baseApi.get(`${apiUrl}/folders/content`),
  getFolderContentById: (id) => baseApi.get(`${apiUrl}/folders/content/${id}`),
  getFoldersTree: () => baseApi.get(`${apiUrl}/folders/allcontent`),
  searchFolders: (query) => baseApi.get(`${apiUrl}/folders/search?name=${query}&limit=10&external=true`),

  getTemplateById: (id) => baseApi.get(`${apiUrl}/templates/${id}`),
  getTemplateSides: (id) => baseApi.get(`${apiUrl}/templates/${id}/sides`),
  getRemovedTemplates: () => baseApi.get(`${apiUrl}/templates/deleted`).then(result =>
    result.reduce((prev, current) => ([...prev, { ...current, type: 'template', groups: [], removed: true }]), [])
  ),

  getUserData: () => baseApi.get(`${apiUrl}/user`),
  getUserGroups: () => baseApi.get(`${apiUrl}/usergroups`),
  getUserPermissions: () => baseApi.get(`${apiUrl}/user/permissions`).then(({ permissions }) => permissions),
  getCurrentTariff: () => baseApi.get(`${apiUrl}/tariffs/instances/current`),
  getAcquiringSubscription: () => baseApi.get(`${apiUrl}/acquiring/subscriptions/active`),

  getCounteragents: (params) => baseApi.get(`${apiUrl}/counteragents/`, { params }),
  getCounteragentById: (id) => baseApi.get(`${apiUrl}/counteragents/${id}`),
  getProducts: (params) => baseApi.get(`${apiUrl}/products`, { params }),
  getProductCategories: () => baseApi.get(`${apiUrl}/products/categories`),
  getProductProperties: () => baseApi.get(`${apiUrl}/productproperties`),

  getYclientsRecords: (params) => baseApi.get(`${apiUrl}/yclients/record/${params.salonId}/${params.entityId}`),
};
